/** Studio music catalog types — mirror backend manifest rows. */

export type MusicMode = 'bed' | 'music_only';

export type MusicTrack = {
  id: string;
  display_name: string;
  file: string;
  has_vocals: boolean;
  bpm?: number | null;
  energy?: string | null;
  tone?: string | null;
  duration_s?: number | null;
  license?: string | null;
  /** Relative `/api/rtts/music/{id}/preview` when live catalog is music-enabled. */
  preview_url?: string | null;
};

/** Volume slider range: 0% → −40 dB, 100% → 0 dB. */
export const GAIN_DB_MIN = -40;
export const GAIN_DB_MAX = 0;
export const DEFAULT_GAME_GAIN_DB = 0;
export const DEFAULT_MUSIC_GAIN_DB = -16;
export const DEFAULT_MUSIC_ONLY_GAIN_DB = -3;
export const DEFAULT_MUSIC_LOOP = true;
export const DEFAULT_MUSIC_FADE_IN_S = 0.75;
export const DEFAULT_MUSIC_FADE_OUT_S = 2.0;
